export default [

    {
      path: '/wasl/company-register',
      name: 'wasl.company-register',
      component: () => import('@/views/wasl/registeration/CompanyRegister'),
      meta: {
        module: 'wasl.companyRegister',
        pageTitle: 'Company Registeration ',
        breadcrumb: [
          { text: 'Register Company', active: true }
        ],
      }
    },
]